export default __webpack_public_path__ + "img/logo-reduced.4a7eb5ef.svg";